import { ContentListSortingType } from '@norlys-a-s/norlys-play-kmm';

import { ContentListProviders, UIElementContent, UIElementStyle } from '@smart-tv/typings/content';

import { toProviderIdentifier, toUIElementContent } from './helpers';
import { kmm } from './kmm';

export async function getContentList(
  universeId: number,
  providers: ContentListProviders,
  mainGenreId: number,
  subGenreId: number,
  style: UIElementStyle,
  itemLimit: number,
  start = 0
): Promise<UIElementContent> {
  const result = await kmm((repo) =>
    repo.getContentList(
      start,
      itemLimit,
      universeId,
      ContentListSortingType.VIEWS,
      mainGenreId,
      subGenreId,
      toProviderIdentifier(providers)
    )
  );

  return toUIElementContent(result, style);
}

export default getContentList;
